import "./SignUp.css";
import useSignUp from "./useSignUp";
import { getTranslatedText as translate } from "../../Localization/Translation";
import LanguageSelect from "../../LanguageSelection/LanguageSelect.js";
function SignUp() {
  const {
    locale,
    eye,
    confirmEyeStyle,
    UserNameError,
    PhoneNumberError,
    PasswordError,
    ConfirmPasswordError,
    passwordType,
    confirmPasswordType,
    Eye,
    ConfirmEye,
    onChangeInput,
    checkInput,
    backToLogIn,
  } = useSignUp();

  return (
    <div className="SignUp-form">
      <div className="signup-form-header-language">
        <div className="SignUp-form-header">
          {translate("signup-form-header", locale)}
        </div>
        {/* Language Selection */}
        <LanguageSelect />
      </div>
      <div>
        <div className="SignUp-form-inputs">
          <div className="form-signup-box">
            {/* phone number */}
            <div className="mb-3">
              <input
                type="text"
                className="form-control"
                id="signup-phone"
                onChange={(event) => onChangeInput(event, "signup-phone")}
                placeholder={translate(
                  "signup-phone-number-placeholder",
                  locale
                )}
                aria-describedby="phoneHelp"
              />
              <div className="invalid-feedback">
                {translate(PhoneNumberError, locale)}
              </div>
              <div id="phoneHelp" className="form-text">
                {translate("signup-phone-number-text", locale)}
              </div>
            </div>
            {/* user name */}
            <div className="mb-3">
              <input
                type="text"
                className="form-control required-input"
                id="signup-user-name"
                onChange={(event) => onChangeInput(event, "signup-user-name")}
                placeholder={translate("signup-user-name-placeholder", locale)}
                aria-describedby="emailHelp"
                required
              />
              <div className="invalid-feedback">
                {translate(UserNameError, locale)}
              </div>
            </div>
            {/* <div className="form-row d-flex mb-3 gap-3">
                        <div className="form-group col-md-3">
                            <select id="inputState" className="form-control">
                                <option selected>{translate('choose-city', locale)}</option>
                                <option>...</option>
                            </select>
                        </div>
                        <div className="form-group col-md-3">
                            <input type="number" className="form-control" id="inputCity" placeholder={translate('building-number', locale)} />
                        </div>
                        <div className="form-group col-md-3">
                            <input type="number" className="form-control" id="inputZip" placeholder={translate('floor-number', locale)} />
                        </div>
                    </div> */}

            {/* password */}
            <div className="input-group mb-3" style={{ position: "relative" }}>
              <input
                type={passwordType}
                className="form-control"
                id="signup-pass"
                onChange={(event) => onChangeInput(event, "signup-pass")}
                placeholder={translate("signup-password-placeholder", locale)}
              />
              <div className="input-group-append">
                <i
                  onClick={Eye}
                  className={`input-group-text eye-pass bi ${
                    eye ? "bi-eye-slash" : "bi-eye"
                  }`}
                ></i>
              </div>
              <div className="invalid-feedback">
                {translate(PasswordError, locale)}
              </div>
            </div>
            {/* confirm password */}
            <div className="input-group mb-3" style={{ position: "relative" }}>
              <input
                type={confirmPasswordType}
                className="form-control"
                id="signup-confirm-pass"
                onChange={(event) =>
                  onChangeInput(event, "signup-confirm-pass")
                }
                placeholder={translate(
                  "signup-password-confirm-placeholder",
                  locale
                )}
              />
              <div className="input-group-append">
                <i
                  onClick={ConfirmEye}
                  className={`input-group-text eye-pass bi ${
                    confirmEyeStyle ? "bi-eye-slash" : "bi-eye"
                  }`}
                ></i>
              </div>
              <div className="invalid-feedback">
                {translate(ConfirmPasswordError, locale)}
              </div>
            </div>
          </div>
          <div className="confirm-signup-buttons">
            {/* Sign up btn */}
            <button
              type="submit"
              onClick={checkInput}
              className="btn btn-primary btn-SignUp-form"
            >
              {translate("signup-btn-text", locale)}
            </button>
            {/* back btn */}
            <button
              type="submit"
              onClick={backToLogIn}
              className="btn btn-secondary"
            >
              {translate("confirm-signup-close-code", locale)}
            </button>
          </div>
        </div>
      </div>
      <hr />
      {/* sign up with */}
      <div className="signup-with">
        <div className="signup-with-head">
          {translate("signup-method-text", locale)}
        </div>
        <div className="row">
          <div className="col signup-method">
            <img
              src="https://img.icons8.com/fluency/48/null/google-logo.png"
              className="signup-method-icon"
              alt="signup-method-icon"
            />
            {translate("signup-method-1-text", locale)}
          </div>
          <div className="col signup-method">
            <img
              src="https://img.icons8.com/color-glass/48/null/mac-os.png"
              className="signup-method-icon"
              alt="signup-method-icon"
            />
            {translate("signup-method-2-text", locale)}
          </div>
        </div>
      </div>
    </div>
  );
}

export default SignUp;
